import { useEffect, useState } from "react";
import { api, fmtDate, fmtTime } from "@/lib/api";

export const SlotPicker = ({ excludeSessionId, value, onChange, days = 14, data: preset }) => {
  const [data, setData] = useState(preset || null);
  const [day, setDay] = useState(preset?.[0]?.date ?? null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (preset) return;
    api.get("/slots", { params: { days, excludeSessionId } })
      .then((r) => { setData(r.data.days); setDay(r.data.days[0]?.date ?? null); })
      .catch(() => setErr("Could not load availability"));
  }, [excludeSessionId, days, preset]);

  if (err) return <div className="err">{err}</div>;
  if (!data) return <div className="center" style={{ minHeight: 120 }}><span className="spin" /></div>;
  if (data.length === 0) return <div className="empty" data-testid="slots-empty">No free slots in the next {days} days.</div>;
  const cur = data.find((d) => d.date === day) || data[0];
  const hour = (iso) => Number(iso.slice(11, 13));
  const groups = [["Morning", (h) => h < 12], ["Afternoon", (h) => h >= 12 && h < 17], ["Evening", (h) => h >= 17]];

  return (
    <div data-testid="slot-picker">
      <div className="daystrip">
        {data.map((d) => (
          <button type="button" key={d.date} className={`daybtn ${cur.date === d.date ? "on" : ""}`} onClick={() => setDay(d.date)} data-testid={`slot-day-${d.date}`}>
            <small>{fmtDate(`${d.date}T00:00:00Z`, { weekday: "short" })}</small>
            <b>{fmtDate(`${d.date}T00:00:00Z`, { day: "numeric" })}</b>
            <small>{d.slots.length} free</small>
          </button>
        ))}
      </div>
      {groups.map(([label, test]) => {
        const slots = cur.slots.filter((s) => test(hour(s)));
        if (!slots.length) return null;
        return (
          <div key={label} style={{ marginTop: 10 }}>
            <div className="ss" style={{ marginBottom: 4, textTransform: "uppercase", letterSpacing: 1, fontSize: 10.5 }}>{label}</div>
            <div className="slots">
              {slots.map((s) => (
                <button type="button" key={s} className={`slot ${value === s ? "on" : ""}`} onClick={() => onChange(s)} data-testid={`slot-${s.slice(0, 16)}`}>{fmtTime(s)}</button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
